module.exports = __webpack_public_path__ + "img/icon-logo.af533f51.svg";